import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BaseComponent, UserService, SupportService, ProductService, environment } from "@mypxplat/xplat/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CreateTicketComponent } from "@mypxplat/xplat/web/features";
import { AppService } from "@mypxplat/xplat/web/core";
import { BreadcrumbItem } from "../fender-ui/layout-header/layout-header.component";

@Component({
  selector: "myp-support",
  templateUrl: "support.component.html",
  standalone: false,
})
export class SupportComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() showPageTitle: boolean = false;
  public destroy$: Subject<any> = new Subject();
  public displayedSection: string;
  public breadcrumbs: BreadcrumbItem[] = [];

  public openTickets: Array<any>;
  public closedTickets: Array<any>;
  public loadingOpen: boolean = false;
  public loadingClosed: boolean = false;
  public refreshing: boolean = false;
  public supportPath: string = null;
  public description: string;

  constructor(
    userService: UserService,
    public appService: AppService,
    public supportService: SupportService,
    public productService: ProductService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {
    super(userService);
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.displayedSection = this._activatedRoute.snapshot.params["category"] || "options";
    this.setDescription();
    this.setBreadcrumbs();
    // Listen to route parameter changes (for browser back/forward navigation)
    this._activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const category = params["category"] || "options";
      if (category !== this.displayedSection) {
        this.switchSection(category, false, true);
      }
      this.setDescription();
      this.setBreadcrumbs();
    });

    this.supportService.openTickets$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.openTickets = result;
      this.loadingOpen = false;
      this.refreshing = false;
    });
    this.supportService.closedTickets$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.closedTickets = result;
      this.loadingClosed = false;
      this.refreshing = false;
    });
    this.switchSection(this.displayedSection);
    this.supportService.getOpenTickets(true);
    this.supportService.getClosedTickets(true);
  }

  setDescription() {
    if (this.displayedSection == "options") {
      this.description = "newdash.fender_support_options_description";
    } else {
      this.description = "newdash.fender_support_recording_description";
    }
  }

  setBreadcrumbs() {
    if (this.displayedSection != "options") {
      this.breadcrumbs = [
        { label: "header.nav.home", routerLink: ["/home"] },
        { label: "fui-header.support", clickHandler: () => this.switchSection("options") },
        { label: "fui-header.recording_software_hardware_support" },
      ];
    } else {
      this.breadcrumbs = [{ label: "header.nav.home", routerLink: ["/home"] }, { label: "fui-header.support" }];
    }
  }

  switchSection(section, force?, skipNavigation?) {
    if (section != this.displayedSection && !skipNavigation) {
      let url = ["support/", section];
      if (section == "options") url = ["support/"];
      this._router.navigate(url);
    }
    this.displayedSection = section;
    this.setDescription();
    this.setBreadcrumbs();
    if (section == "open") {
      this.loadingOpen = true;
      this.supportService.getOpenTickets(force);
    } else if (section == "closed") {
      this.loadingClosed = true;
      this.supportService.getClosedTickets(force);
    }
  }

  goToFenderSupport() {
    window.open("https://www.fender.com/pages/store-policies#erid45258197", "_blank");
  }

  refresh() {
    this.refreshing = true;
    if (this.displayedSection == "open" || this.displayedSection == "closed") {
      this.switchSection(this.displayedSection, true);
    }
  }

  createTicket() {
    //if (this.user.active) {
    if (this.user.firstName && this.user.lastName) {
      const modalRef = this.appService.showModal(CreateTicketComponent, { size: "lg", ariaLabelledBy: "modal-title" });
      modalRef.result.then(
        (result) => {
          this.refreshing = true;
          this.loadingOpen = true;
          this.switchSection("open", true);
          if (result.ticket_id) {
            this._router.navigate(["/support/ticketdetail/", result.ticket_id]);
          }
        },
        (error) => {}
      );
    } else {
      if (confirm("You need to fill out your first and last name before creating a support ticket.")) {
        this._router.navigate(["/account/general/"]);
      }
    }
    // } else {
    //   alert("Please activate your account before creating a Support Ticket.");
    // }
  }

  goToTicket(ticket) {
    this._router.navigate(["/support/ticketdetail/", ticket.id]);
  }

  goToReturnAuth() {
    this._router.navigate(["/rma"]);
  }
  handleRmaRefresh(event: boolean): void {
    this.refreshing = !event;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
